"use client";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { Disc } from "../Disc/index.js";
import { Heading } from "../Heading/index.js";
import { Image } from "../Image/index.js";
import { P } from "../Text/index.js";
import { actionCardVariants } from "./ActionCard.variants.js";
const DISC_PALETTE = {
    brand: 'marketingBrand',
    primary: 'primary',
    neutral: 'neutral'
};
const ActionCard_ActionCard = /*#__PURE__*/ forwardRef(function(props, ref) {
    const { role, href, onClick, anchorProps, buttonProps, ariaLabel, elevated = true, readOnly, media = true, mediaType = 'icon', mediaContent, mediaPalette = 'primary', eyebrow, heading, headingLineClamp = 2, body, actionType = 'link', className, slots = {} } = props;
    const { baseSlot, mediaSlot, contentSlot, eyebrowSlot, headingSlot, bodySlot, iconSlot, iconInnerSlot } = actionCardVariants({
        elevated,
        mediaType,
        actionType,
        readOnly
    });
    const renderMediaSlot = ()=>{
        if (!media) return null;
        if ('image' === mediaType) {
            const imageSrc = 'string' == typeof mediaContent ? mediaContent : mediaContent?.src;
            const imageAlt = 'object' == typeof mediaContent && null !== mediaContent ? mediaContent.alt : '';
            return /*#__PURE__*/ jsx("div", {
                className: cn(mediaSlot(), slots.mediaSlot),
                children: /*#__PURE__*/ jsx("div", {
                    className: "h-full min-h-16 min-w-14 overflow-clip",
                    children: /*#__PURE__*/ jsx(Image, {
                        src: imageSrc,
                        alt: imageAlt,
                        width: "full",
                        height: "full",
                        objectFit: "cover"
                    })
                })
            });
        }
        const iconContent = 'string' == typeof mediaContent ? mediaContent : 'date_range';
        return /*#__PURE__*/ jsx("div", {
            className: cn(mediaSlot(), slots.mediaSlot),
            children: /*#__PURE__*/ jsx(Disc, {
                content: iconContent,
                contentType: "icon",
                size: "md",
                palette: DISC_PALETTE[mediaPalette],
                emphasis: "medium"
            })
        });
    };
    const renderContentSlot = ()=>/*#__PURE__*/ jsxs("div", {
            className: cn(contentSlot(), slots.contentSlot),
            children: [
                eyebrow && /*#__PURE__*/ jsx(P, {
                    textStyle: "body3",
                    lineClamp: 1,
                    palette: "neutral",
                    shade: "10",
                    className: cn(eyebrowSlot(), slots.eyebrowSlot),
                    children: eyebrow
                }),
                heading && /*#__PURE__*/ jsx(Heading, {
                    as: "h6",
                    lineClamp: headingLineClamp,
                    palette: "neutral",
                    shade: "13",
                    className: cn(headingSlot(), slots.headingSlot),
                    children: heading
                }),
                body && /*#__PURE__*/ jsx(P, {
                    textStyle: "body2",
                    lineClamp: 2,
                    palette: "neutral",
                    shade: "13",
                    className: cn(bodySlot(), slots.bodySlot),
                    children: body
                })
            ]
        });
    const renderIconSlot = ()=>/*#__PURE__*/ jsx("div", {
            className: cn(iconSlot(), slots.iconSlot),
            children: /*#__PURE__*/ jsx("span", {
                className: cn(iconInnerSlot(), slots.iconInnerSlot),
                children: /*#__PURE__*/ jsx(CdnIcon, {
                    iconName: 'info' === actionType ? 'info' : 'arrow_forward',
                    size: "20",
                    palette: "neutral",
                    shade: "11",
                    "aria-hidden": "true"
                })
            })
        });
    const baseClasses = cn(baseSlot(), slots.baseSlot, className);
    if (readOnly) return /*#__PURE__*/ jsxs("div", {
        ref: ref,
        className: baseClasses,
        children: [
            renderMediaSlot(),
            renderContentSlot()
        ]
    });
    const innerContent = /*#__PURE__*/ jsxs(Fragment, {
        children: [
            renderMediaSlot(),
            renderContentSlot(),
            renderIconSlot()
        ]
    });
    if ('link' === role) return /*#__PURE__*/ jsx("a", {
        ref: ref,
        href: href,
        "aria-label": ariaLabel,
        onClick: onClick,
        className: baseClasses,
        ...anchorProps,
        children: innerContent
    });
    return /*#__PURE__*/ jsx("button", {
        ref: ref,
        type: "button",
        "aria-label": ariaLabel,
        onClick: onClick,
        className: baseClasses,
        ...buttonProps,
        children: innerContent
    });
});
ActionCard_ActionCard.displayName = 'ActionCard';
export { ActionCard_ActionCard as ActionCard };
